import type { QueryRollupLevelOption } from "./types";

/** Canonical identifier for the transaction grain in level stacks and
 *  `supportedLevels` metadata. */
export const TRANSACTION_LEVEL = "transaction";

/** Whether a column's Semantic Layer mappings support the transaction level. */
export const supportsTransactionLevel = (supportedLevels: ReadonlyArray<string>): boolean =>
  supportedLevels.includes(TRANSACTION_LEVEL);

/** Restrict the curated level catalogue to a field's supported levels.
 *
 * An empty `supportedLevels` means the catalogue carries no mapping data
 * for the column (e.g. an older Semantic Layer response) — keep the full
 * catalogue so the picker never regresses to an empty select. */
export const filterLevelOptionsBySupported = (
  options: ReadonlyArray<QueryRollupLevelOption>,
  supportedLevels: ReadonlyArray<string>,
): ReadonlyArray<QueryRollupLevelOption> => {
  if (supportedLevels.length === 0) return options;
  const filtered = options.filter((option) => supportedLevels.includes(option.value));
  return filtered.length > 0 ? filtered : options;
};
